module.exports = __webpack_public_path__ + "static/media/paleBanner.9e5f00fe.png";